module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/2-249333beeaf38fd4d841a59d0e9a10ad.jpg";